var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#666",
  strokeWidth: 2,
  clipPath: "url(#upload-photo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M1.5 3.5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "m2.5 14.5 7.697-5.987a2 2 0 0 1 2.545.074L15.5 11"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 0.5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "upload-photo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5.5h16v16H.5z"
})))));
export { SvgUploadPhoto as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3IiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMzc3N180ODkyNCkiPgogICAgPHBhdGggZD0iTTEuNSAzLjVDMS41IDIuMzk1NDMgMi4zOTU0MyAxLjUgMy41IDEuNUgxMy41QzE0LjYwNDYgMS41IDE1LjUgMi4zOTU0MyAxNS41IDMuNVYxMy41QzE1LjUgMTQuNjA0NiAxNC42MDQ2IDE1LjUgMTMuNSAxNS41SDMuNUMyLjM5NTQzIDE1LjUgMS41IDE0LjYwNDYgMS41IDEzLjVWMy41WiIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik0yLjUgMTQuNUwxMC4xOTcyIDguNTEzMjhDMTAuOTUzNiA3LjkyNDk5IDEyLjAyMSA3Ljk1NTg0IDEyLjc0MjEgOC41ODY4M0wxNS41IDExIiBzdHJva2U9IiM2NjY2NjYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICA8Y2lyY2xlIGN4PSI2IiBjeT0iNiIgcj0iMC41IiBzdHJva2U9IiM2NjY2NjYiIHN0cm9rZS13aWR0aD0iMiIvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMzc3N180ODkyNCI+CiAgICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAwLjUpIi8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+";